import { Label, ListBox, Select } from '@heroui/react'
import type { Identity, Priority } from '../lib/types'
import { branchOptionOn, type BranchSettingsView } from '../lib/branchSettings'
import type { StaffKey } from '../lib/staffText'
import { useStaffText } from '../ui/StaffText'

const NAME: Record<Priority, StaffKey> = {
  standard: 'common.standard',
  priority: 'common.priority',
  vip: 'common.vip',
}

/** Reception offers a priority when the branch has the option on and the person may set one. */
export function offersPriority(identity: Pick<Identity, 'options' | 'permissions'>, settings?: BranchSettingsView | null): boolean {
  return branchOptionOn(settings, identity, 'priorityTickets') && identity.permissions.includes('ticket.priority')
}

/** What a ticket is issued as: Standard unless the choice is offered. */
export function issuedPriority(offered: boolean, chosen: Priority): Priority {
  return offered ? chosen : 'standard'
}

/** Standard / Priority / VIP beside the customer's details; nothing while it is not offered. */
export function PriorityChoice({
  offered,
  value,
  onChange,
}: {
  offered: boolean
  value: Priority
  onChange: (next: Priority) => void
}) {
  const { say } = useStaffText()
  if (!offered) return null
  return (
    <Select className="rx-field rx-priority" variant="secondary" value={value} onChange={(next) => next != null && onChange(String(next) as Priority)}>
      <Label>{say('common.priority')}</Label>
      <Select.Trigger>
        <Select.Value />
        <Select.Indicator />
      </Select.Trigger>
      <Select.Popover>
        <ListBox>
          {(Object.keys(NAME) as Priority[]).map((p) => (
            <ListBox.Item key={p} id={p} textValue={say(NAME[p])}>
              {say(NAME[p])}
              <ListBox.ItemIndicator />
            </ListBox.Item>
          ))}
        </ListBox>
      </Select.Popover>
    </Select>
  )
}
